<script lang="ts" context="module">
  import { getAppConfig } from '../../../../../common/config/app-config';
  import { CONSTANTS } from '../../../../../common/config/constants';
  import { isDirectionRTL } from '../../../../../common/util';
  import { ProductTilePriceGroupVariantType } from '../product-tile-main';

  const { primeLevel, joodFullCappingLimitReached } = getAppConfig();
  const isRTL = isDirectionRTL();
  const { VIPPRIME } = CONSTANTS;
</script>

<script lang="ts">
  import ProductTileJoodWalletCreditAmount from './ProductTileJoodWalletCreditAmount.svelte';

  export let creditPoints;
  export let isTacticalFlag = null;
  export let variant: ProductTilePriceGroupVariantType;
</script>

{#if creditPoints > 0 && !joodFullCappingLimitReached}
  <section
    class="c_product-price-jood-wallet-container c_jood-wallet-benefit-container variant-{variant} {primeLevel
      ? 'user-PRIME'
      : 'user-NOPRIME'}"
    class:rtl={isRTL}
  >
    <ProductTileJoodWalletCreditAmount {isTacticalFlag} {creditPoints} {variant} priceType={VIPPRIME} />
  </section>
{/if}
